import { render, staticRenderFns } from "./DesgloseCategoriasComponent.vue?vue&type=template&id=821a9858"
import script from "./DesgloseCategoriasComponent.vue?vue&type=script&lang=js"
export * from "./DesgloseCategoriasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports